// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".big-icon[data-v-72b06be4]{position:relative;border-radius:10px!important}.color-grey06[data-v-72b06be4]{color:rgba(0,0,0,.6)}@media(min-width:370px)and (max-width:600px){.big-icon[data-v-72b06be4]{flex-wrap:nowrap;padding-bottom:25px}[data-v-72b06be4] .v-btn:not(.v-btn--round).v-size--large{min-width:55px}}", ""]);
// Exports
module.exports = exports;
